import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	videoListContainer: {
		height                 : "100vh",
		width                  : "100%",
		padding                : "1rem 1rem 0rem 1rem",
		"&::-webkit-scrollbar" : {
			width      : "0", /* Remove scrollbar space */
			background : "transparent" /* Optional: just make scrollbar invisible */
		},
		display       : "flex",
		flexDirection : "column"
	},
	titleContainer: {
		display    : "flex",
		alignItems : "center"
	},
	titleText: {
		fontSize   : "1.7rem",
		fontWeight : "500"
	},
	svgIcon: {
		...theme.other.svgIcons.size25
	},
	absoluteContainer: {
		flexBasis: "0px"
	},
	listContainer: {
		display       : "flex",
		flexDirection : "column"
	},
	emptyContainer: {
		height         : "100%",
		display        : "flex",
		flexDirection  : "column",
		alignItems     : "center",
		justifyContent : "center",
		width          : "100%"
	}
} ) );
